/** Which request of a refresh-and-retry was answered: the renewal itself, or the original request sent again. */
export type RefreshStage = 'refresh' | 'retry'

/**
 * Whether an answer during a refresh-and-retry means the session is gone.
 *
 * 🔴 **Only a refusal ends a session.** A renewal refused with 401 (no token, or an expired or revoked one) or 403
 * (the account no longer passes this program's gate), or a retry still answered 401 with the renewed token. Anything
 * else — a network drop, a 502 mid-deploy, a 400 for a bad field, a 403 for a missing permission — is the page's
 * error, and ending the session on it sends an operator to the login screen with their form thrown away.
 *
 * Kept free of imports so `pnpm test` covers it: this decision has been wrong on both sides before.
 */
export function endsSession(stage: RefreshStage, status: number): boolean {
  if (stage === 'refresh') {
    return status === 401 || status === 403
  }
  return status === 401
}
